// extracted by mini-css-extract-plugin
export var arrows = "_7z-6";
export var decrementer = "_7z-a";
export var disabled = "_7z-4";
export var error = "_7z-1";
export var hiddenText = "_7z-b";
export var incrementer = "_7z-9";
export var input = "_7z-8";
export var inputWrapper = "_7z-0";
export var leadingIcon = "_7z-c";
export var readonly = "_7z-3";
export var regular = "_7z-7";
export var small = "_7z-5";
export var warning = "_7z-2";